import { Typography } from "@material-ui/core";
import CardTable from "components/CardTable/CardTable";
import RegularButton from "components/CustomButtons/Button";
import React, { useRef, useState } from "react";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import { columnsContracts } from "views/Crm/columnsContracts";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { useDispatch, useSelector } from "react-redux";
import { blue, red } from "@material-ui/core/colors";
import AttachmentIcon from "@material-ui/icons/Attachment";
import { styleShare } from "../orders/OrderCard";
import { uploadCustomerContract } from "redux/actions/customers/customersAction";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import { animations } from "helpers/animations";

export const CustomerDocumentation = () => {
  const dispatch = useDispatch();
  const { contracts, customer, loadingPdf } = useSelector(
    ({ customersReducer }) => customersReducer
  );
  const { token } = useSelector(({ login }) => login);
  const fileInputRef = useRef();
  const [file, setFile] = useState(null);
  const [pdfError, setPdfError] = useState({
    error: false,
    message: "",
  });
  const { error, message } = pdfError;
  const handleButtonClick = () => {
    fileInputRef.current.click();
  };
  const handleFileChange = (data) => {
    if (data) {
      if (data.size >= 1500000) {
        setPdfError({
          error: true,
          message: "El archivo no puede pesar mas de 1.4Mb",
        });
        return;
      }
      if (data.name.includes(".pdf")) {
        setFile(data);
        setPdfError({
          error: false,
          message: "",
        });

        return;
      } else {
        setPdfError({
          error: true,
          message: "Ups... Solo se permiten archivos .pdf",
        });
        return;
      }
    }
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("contract", file, file.name);
    dispatch(uploadCustomerContract(customer?.id, formData, token));
    setFile(null);
  };

  return (
    <CardTable
      hasHeader
      title="Lista de Contratos"
      icon={<ImportContactsIcon />}
      columns={columnsContracts}
      data={contracts}
      blockBtn
      showPageSize={false}
      hasControl
      controls={
        <div style={{ transition: ".4s ease", ...styleShare, gap: 8 }}>
          <RegularButton
            color="info"
            justIcon
            round
            size="small"
            tooltip="Adjuntar PDF"
            onClick={handleButtonClick}
          >
            <AttachmentIcon style={{ margin: 0 }} />
            <input
              type="file"
              style={{ display: "none" }}
              ref={fileInputRef}
              onChange={(e) => handleFileChange(e.target.files[0])}
            />
          </RegularButton>
          {file?.name && !error ? (
            <RegularButton
              color="success"
              justIcon
              round
              size="small"
              tooltip={file?.name ? `Cargar archivo - ${file.name}` : ""}
              onClick={handleSubmit}
            >
              <CloudUploadIcon style={{ margin: 0 }} />
            </RegularButton>
          ) : (
            <Typography variant="caption" style={{ color: red[300] }}>
              {message}
            </Typography>
          )}
          {loadingPdf && (
            <RegularButton
              color="transparent"
              justIcon
              round
              size="small"
              tooltip="Cargando PDF..."
            >
              <QueryBuilderIcon
                className={animations.fadeIn}
                style={{ margin: 0, color: blue[300] }}
              />
            </RegularButton>
          )}
        </div>
      }
    />
  );
};
